import React from "react";
import "./Maitre.css";

const Maitre = ({ text, desc, imgdata }) => {
  return (
    <>
      <div className="text-white flex flex-col md:flex-row justify-center items-center h-[100%] md:!h-[100vh] md:!px-42">
        <div className="md:flex-1">
          <h1 className="text-center md:text-left font-semibold text-[26px] md:text-[60px]">
            {text}
          </h1>
          <p className="text-center md:text-left font-medium text-[16px] md:text-[30px]">{desc}</p>
        </div>
        <div className="md:flex-1 flex justify-center items-center">
          <img src={imgdata} alt="image" className="w-[70%] md:w-[100%]" />
        </div>
      </div>
    </>
  );
};

export default Maitre;
